import EarlyPayHistoryWidget from '@/enterprise/components/Homepage/EarlyPayHistoryWidget';
import HeroBanner from '@/enterprise/components/Homepage/HeroBanner';
import InvoiceCentralWidget from '@/enterprise/components/Homepage/InvoiceCentralWidget';
import OfferActivityWidget from '@/enterprise/components/Homepage/OfferActivityWidget';
import MarketingWidget from '@/enterprise/features/homepage/homePageBanner/MarketingWidget/MarketingWidget';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import NewDivisionAlert from '../components/NewDivisionAlert';
import useEnableUnification from '../components/useEnableUnification';
import useTakerMarkets from '../data/useTakerMarkets';

const Homepage = () => {
  const enableUnification = useEnableUnification();
  const { data: takerMarkets } = useTakerMarkets();

  if (!enableUnification) {
    return <NavigateWithRedirect to={asEnterpriseLink('customers')} />;
  }

  return (
    <div>
      <NewDivisionAlert takerMarkets={takerMarkets} referrer="homepage" className="pb-6" />
      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="grow">
          <HeroBanner />
        </div>
        <div className="shrink-0 lg:w-1/3">
          <MarketingWidget />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 pt-12 lg:grid-cols-3">
        <InvoiceCentralWidget />
        <OfferActivityWidget />
        <EarlyPayHistoryWidget />
      </div>
    </div>
  );
};

export default Homepage;
